// InAppDocViewer/PdfViewerModal.jsx
//
// Public entry for the in-app PDF viewer modal. The heavy body (PdfViewerModalInner
// + pdfjs-dist) is code-split behind React.lazy, so it is fetched only when the
// modal is actually opened with a PDF — keeping it out of the main bundle.
//
// This is the additive, flag-gated replacement for `window.open(url, "_blank")`
// on PDF documents. Callers render it always but pass `open` + `url`; it renders
// nothing (and loads nothing) until open === true.

import React, { Suspense } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";

const PdfViewerModalInner = React.lazy(() => import("./PdfViewerModalInner"));

export default function PdfViewerModal({ open, url, onClose }) {
  if (!open || !url) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="inapp-pdf-viewer"
      aria-describedby="inapp-pdf-viewer-body"
    >
      {/* Modal requires a single focusable child; the Box is the fallback shell
          shown while the lazy chunk loads. */}
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "65vw",
          height: "85vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          outline: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: "8px",
        }}
      >
        <Suspense
          fallback={
            <div style={{ fontFamily: "DM Sans", color: "#123051" }}>
              Loading viewer…
            </div>
          }
        >
          <PdfViewerModalInner url={url} onClose={onClose} />
        </Suspense>
      </Box>
    </Modal>
  );
}
